<div class="declaration-modal">
  <div class="declaration-modal-header">
    <button
      class="mat-button_with-icon"
      type="button"
      mat-button
      matDialogClose
    >
      <mat-icon> arrow_back</mat-icon>
      Закрити
    </button>
  </div>

  <mat-progress-bar [style.opacity]="+isLoading" mode="indeterminate"></mat-progress-bar>

  <div class="declaration-modal-content">
    <div class="declaration-info">
      <div class="declaration-info-header">
        <span class="declaration-number">
         {{ declarationPaymentCostsInfo.Number }}
        </span>
        <div class="info-cell">
          <div class="info-cell__label">Відправник</div>
          <div class="info-cell__content">
            {{ senderName }}
          </div>
        </div>
      </div>

      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <div class="accordion-header">
              <div class="info-cell__content">Мито</div>
              <div
                class="info-cell__content">{{ getFormattedCost(declarationPaymentCostsInfo.TotalInternationalDelivery) }}
              </div>
            </div>
          </mat-expansion-panel-header>

          <div class="accordion-content">
            <div class="accordion-content-item" *ngIf="declarationPaymentCostsInfo.TotalCustomsBrokerageClearance">
              <div class=" ">Митне декларування</div>
              <div class=" ">{{ getFormattedCost(declarationPaymentCostsInfo.TotalCustomsBrokerageClearance) }}</div>
            </div>

            <div class="accordion-content-item" *ngIf="declarationPaymentCostsInfo.TotalCustomsPayments">
              <div class=" ">Обслуговування</div>
              <div class=" ">{{ getFormattedCost(declarationPaymentCostsInfo.TotalCustomsPayments) }}</div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="invoice-info" *ngIf="declarationData?.Documents?.length">
      <div *ngFor="let invoice of declarationData.Documents" class="invoice-info-row">
        <div class="info-cell">
          <div class="info-cell__label">Номер посилки</div>
          <div class="info-cell__content">
            <ng-container *ngIf="invoice.DocumentNumber; else dash">
              {{ invoice.DocumentNumber }}
            </ng-container>
          </div>
        </div>

        <div class="info-cell">
          <div class="info-cell__label">Вага</div>
          <div class="info-cell__content">
            <ng-container *ngIf="invoice.FactualWeight; else dash">
              {{ invoice.FactualWeight }}
            </ng-container>
          </div>
        </div>

        <div class="info-cell">
          <div class="info-cell__label">Об’ємна вага</div>
          <div class="info-cell__content">
            <ng-container *ngIf="invoice.VolumetricWeight; else dash">
              {{ invoice.VolumetricWeight }}
            </ng-container>
          </div>
        </div>

        <div class="info-cell">
          <div class="info-cell__label">Місць</div>
          <div class="info-cell__content">
            <ng-container *ngIf="invoice.SeatsAmount; else dash">
              {{ invoice.SeatsAmount }}
            </ng-container>
          </div>
        </div>

        <div class="info-cell">
          <div class="info-cell__label">Опис</div>
          <div class="info-cell__content">
            <ng-container *ngIf="invoice.CargoDescriptionString; else dash">
              {{ invoice.CargoDescriptionString }}
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="declaration-modal-footer">
    <button
      (click)="initPayment()"
      [disabled]="isLoading || paymentPopupOpened"
      color="primary"
      mat-raised-button
      type="button"
    >
      Сплатити
    </button>
  </div>
</div>

<ng-template #dash>—</ng-template>
